// VerticalProgressBar.jsx
import React, { useEffect, useRef } from 'react';
import styles from './VerticalProgressBar.module.css';

const VerticalProgressBar = ({
  percent = 0,
  height = 200,
  width = 48,
  colorStart = '#6a11cb',
  colorEnd = '#2575fc',
  style
}) => {
  const clampedPercent = Math.max(0, Math.min(100, percent));
  const containerRef = useRef(null);

  // Обновляем CSS-переменную для анимации при изменении percent
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.style.setProperty('--target-height', `${clampedPercent}%`);
    }
  }, [clampedPercent]);

  return (
    <div
      ref={containerRef}
      className={styles.container}
      style={{
        height: `${height}px`,
        width: `${width}px`,
        ...style
      }}
    >
      <div
        className={styles.fill}
        style={{
          background: `linear-gradient(180deg, ${colorStart} 0%, ${colorEnd} 100%)`,
        }}
      />
      <div className={styles.label}>
        {/* {Math.round(clampedPercent)} */}
      </div>
    </div>
  );
};

export default VerticalProgressBar;